import moment from 'moment';

export const normalizedString = (value: string) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

export const transformBirthDate = (birthDate?: Date) => (birthDate ? moment(birthDate).format('YYYY-MM-DD') : '');
